<template v-slot:append>
  <v-dialog
      max-width="75%"
      persistent
      no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="75%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <dd-sub-header>
                検索条件
          </dd-sub-header>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="発注営業所コード/名称"
                    v-model="conditions.hacchuEigyoshoCd"
                    ref="hacchuEigyoshoCd"
                    :required=false
                    :length=100
                    :valueType="ctypes.InputTypes.Free"
                    :itemList="filteredEigyoshoList"
                    titleText="営業所検索"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    :readonly="eigyoshoReadOnly"
                    :headerList="eigyoshoHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="開始"
                              label="発注日"
                              v-model="conditions.hacchuStartYmdString"
                              ref="hacchuStartYmdString"
                              :length="10"
                              :required="false"
                              :valueType="ctypes.InputTypes.Date"/>
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="終了"
                              v-model="conditions.hacchuEndYmdString"
                              ref="hacchuEndYmdString"
                              :length="10"
                              :required="false"
                              :valueType="ctypes.InputTypes.Date"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="発注担当者コード/名称"
                    :required=false
                    v-model="conditions.insUserCd"
                    ref="insUserCd"
                    :length=100
                    :valueType="ctypes.InputTypes.Free"
                    :itemList="filteredJininList"
                    :eigyoshoReadOnly="eigyoshoReadOnly"
                    titleText="担当者検索"
                    item-value="jininCd"
                    item-text="jininNm"
                    :headerList="jininHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="委託先コード/名称"
                    :required=false
                    v-model="conditions.hacchusakiCd"
                    ref="hacchusakiCd"
                    :length=100
                    :valueType="ctypes.InputTypes.Free"
                    :itemList="filteredTorihikisakiList"
                    titleText="委託先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="torihikisakiHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="開始"
                              label="支払予定日"
                              v-model="conditions.shiharaiYoteiStartYmdString"
                              ref="shiharaiYoteiStartYmdString"
                              :length="10"
                              :required="false"
                              :valueType="ctypes.InputTypes.Date"/>
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="終了"
                              v-model="conditions.shiharaiYoteiEndYmdString"
                              ref="shiharaiYoteiEndYmdString"
                              :length="10"
                              :required="false"
                              :valueType="ctypes.InputTypes.Date"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-toolbar class="pa-0 ma-0" flat dense>
                  <v-spacer />
                  <dd-default-button
                      class="ml-2"
                      dark
                      dense
                      @click="onSearchButtonClick">
                      検索
                  </dd-default-button>
                  <dd-default-button
                      class="ml-2"
                      dark
                      dense
                      @click="onClearButtonClick">
                      クリア
                  </dd-default-button>
                </v-toolbar>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols=6>
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                    label="検索結果"
                    v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                    label="絞込結果"
                    v-model="filteredRowCount"/>
            </v-col>

          </v-row>
          <v-row no-gutters>
            <v-col :cols="12">
              <dd-data-table
                  v-model="selectedItem"
                  calculate-widths
                  height="25vh"
                  item-key="hacchuKihonId"
                  showSelect
                  singleSelect
                  @dblclick:row="onRowDoubleClick"
                  @click:row="onRowClick"
                  :headers="headers"
                  :items="filteredRows"
                  :search="searchText"
                  :loading="loading"
                  :header-props="{sortByText: '並び替え'}"
                  :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                  loading-text="検索中のため、少々お待ちください。"
                  items-per-page=100
                  :itemsPerPage=100
                  fixed-header
                  locale="ja-jp"
                  no-data-text="利用可能なデータはありません。"
                  dense
                  :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer/>
        <dd-footer-button
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'
import header from '@/ddv2.library/header'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')

export default {
  name: 'DdV2JutyuKensakuDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDataTable,
    DdRowCountBox,
    DdCodeTextBox,
    DdDateBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      hacchuEigyoushoCd: '',
      hacchuStartYmdString: '',
      hacchuEndYmdString: '',
      nyuryokuTantoushaCd: '',
      hacchusakiCd: '',
      shiharaiYoteiStartYmdString: '',
      shiharaiYoteiEndYmdString: ''
    },
    searchText: '',
    title: '発注検索',
    ctypes: controls,
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    page: 1
  }),
  created () {
    console.log('screen created')
    // this.calcHeightTargets = ['calcRow1', 'calcRow2', 'calcRow3", "calcFooter']
    // this.Effects.loadStart()
    this.$store.dispatch('system/setViewTitle', '発注検索')
    this.eigyoshoHeader = header.mstEigyoshoHeaders
    this.torihikisakiHeader = header.mstTorihikisakiHeaders
    this.jininHeader = header.mstJininHeaders
    /*
    this.eigyoshoHeader = [
      { width: '60px', text: '営業所コード', value: 'eigyoshoCd' },
      { width: '90px', text: '営業所名', value: 'eigyoshoNm' }
    ]
    this.torihikisakiHeader = [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ]
    this.jininHeader = [
      { width: '60px', text: '担当者コード', value: 'jininCd' },
      { width: '90px', text: '担当者姓', value: 'jininNmSei' },
      { width: '90px', text: '担当者名', value: 'jininNmMei' }
    ]
    */
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target) && (elem.shiiresakiFlg || elem.hacchusakiFlg)
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
              (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.hacchuYmdDisp = filter.dateFormatter(elem.hacchuYmd)
        elem.shiharaiYoteiYmdDisp = filter.dateFormatter(elem.shiharaiYoteiYmd)
        elem.shiharaiKingakuDisp = filter.numericFormatter(elem.shiharaiKingaku)
        elem.hacchuEigyoshoNmDisp = elem.hacchuEigyoshoCd + ' ' + elem.hacchuEigyoshoNm
        elem.hacchusakiNmDisp = elem.hacchusakiCd + ' ' + elem.hacchusakiNm
        return elem
      })
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('HacchuKensakuDialog.defineHeaderPromise')
            this.headers = [
              { text: '発注番号', value: 'hacchuNo' },
              { text: '発注日', value: 'hacchuYmdDisp', align: 'center' },
              { text: '発注営業所', value: 'hacchuEigyoshoNmDisp' },
              { text: '発注先', value: 'hacchusakiNmDisp' },
              // { width: '60px', text: '支払区分', value: 'shiharaiKbn' },
              { text: '支払予定日', value: 'shiharaiYoteiYmdDisp', align: 'center' },
              { text: '支払ステータス', value: 'shiharaiStatusNm' },
              { text: '支払金額', value: 'shiharaiKingakuDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.clear(false)
        },
        savedInputRestorePromise: (c) => {
          console.log('HacchuKensakuDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            this.loadFromCacheById('VwCD2comd0090')
              .then((c) => {
                console.log('HacchuKensakuDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('JyutyuKensakuDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            // this.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('HacchuKensakuDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('HacchuKensakuDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            conditions: this.conditions
          }
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      this.clear(false)
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem[0])
      }
      this.clear(false)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2comd0090/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('VwCD2comd0090', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    /*
    onSearchButtonClick: function (e) {
      const isValid = this.validateAll(this.$refs)
      console.log('validate all ', isValid)
      if (isValid) {
        console.log('serach clicked')
        this.search()
      }
    },
    search: function () {
      console.log('serach process')
      const self = this
      self.loading = true
      self.HttpClient
        .post('/api/v1/VwCD2comd0090/Search', self.conditions)
        .then((data) => {
          self._setMessages(data).then(() => {
            if (!data.isValid) {
              self.loading = false
              return
            }
            self.rows = data.payload

            self.saveToChache('VwCD2comd0080', { rows: self.rows, conditions: self.conditions })
              .then(() => {
                self.loading = false
              })
          })
        }).catch(function (error) {
          console.log('post error')
          console.log(error)
          self.loading = false
        })
    },
    */
    clear: function (isRemainRows) {
      console.log('clear', this.torihikisakiList)
      return new Promise(resolve => {
        this.conditions = {
          hacchuEigyoushoCd: this.userEigyoshoCd,
          hacchuStartYmdString: '',
          hacchuEndYmdString: '',
          insUserCd: '',
          hacchusakiCd: '',
          shiharaiYoteiStartYmdString: '',
          shiharaiYoteiEndYmdString: ''
        }
        if (!isRemainRows) {
          this.rows = []
          this.searchText = ''
          this.selectedItem = []
        }
        resolve()
      })
    },
    clearExec: function () {
      console.log('clearExec')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('clearExec ...')

            this.conditions = {
              hacchuEigyoushoCd: this.userEigyoshoCd,
              hacchuStartYmdString: '',
              hacchuEndYmdString: '',
              insUserCd: '',
              hacchusakiCd: '',
              shiharaiYoteiStartYmdString: '',
              shiharaiYoteiEndYmdString: ''
            }
            this.rows = []
            this.searchText = ''
            this.selectedItem = []
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      /**
       * クリアボタン押下処理
       * @event click
       * @type {Event}
       */
      this.Effects.loadStart()
      this.clearExec()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      this.clear(false)
    },
    validate: function () {
      return true
    },
    searchValidate: function () {
      console.log('validating')
      var msg
      if (this.conditions.hacchuStartYmdString && this.conditions.hacchuEndYmdString) {
        msg = validators.compareDate(this.conditions.hacchuStartYmdString, this.conditions.hacchuEndYmdString)
        if (msg !== undefined) {
          this.$refs.hacchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.hacchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.conditions.shiharaiYoteiStartYmdString && this.conditions.shiharaiYoteiEndYmdString) {
        msg = validators.compareDate(this.conditions.shiharaiYoteiStartYmdString, this.conditions.shiharaiYoteiEndYmdString)
        if (msg !== undefined) {
          this.$refs.shiharaiYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shiharaiYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
